import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderTitleService {

  constructor(
  ) { }

  private title = new BehaviorSubject<string>("Digitalsupport Ticketing");
  title$ = this.title.asObservable();

  setTitle(newTitle: string): void {
    this.title.next(newTitle);
  }

  getTitle(): string {
    return this.title.value;
  }
}
